export const GLOBAL_TEMPLATE_PREVIEW_VALUES = {
  companyName: 'MyLocalForce',
  supportEmail: 'support@mylocalforce.com.au',
  websiteUrl: 'https://www.mylocalforce.com',
  dashboardUrl: 'https://www.mylocalforce.com/dashboard',
};

export const SYSTEM_TEMPLATE_PLACEHOLDERS = [
  'companyName',
  'supportEmail',
  'websiteUrl',
  'dashboardUrl',
];

const TEMPLATE_PREVIEW_VALUES = {
  providerName: 'Alex Johnson',
  customerName: 'Taylor Smith',
  serviceName: 'Deep Cleaning',
  date: 'April 12, 2026',
  time: '10:00 AM',
  address: '25 George Street, Sydney NSW',
  totalAmount: 'A$120.00',
  providerEarnings: 'A$95.00',
  customerPhone: '+61 400 123 456',
  otp: '482913',
  validMinutes: '10',
  serviceStartedAt: 'April 12, 2026, 10:05 AM',
  attemptNumber: '2',
  note: 'I called and waited outside for 10 minutes.',
  attemptTime: 'April 12, 2026, 10:20 AM',
  bookingShortId: 'BK12345678',
  ttlMinutes: '5',
  selectedDate: 'April 12, 2026',
  selectedTime: '10:00 AM',
  amountPaid: '$120.00',
  expiryDate: '2026-05-15',
  daysRemaining: '12',
  bookingId: 'BK12345678',
  category: 'Home Services',
  priceText: '$120 AUD',
  providerEarningsText: '$95.00',
  reportDate: 'April 4, 2026',
  totalEarnings: '$2,450.00',
  thisMonth: '$640.00',
  pending: '$180.00',
  completedJobs: '18',
  currentDate: 'April 4, 2026',
  pdfUrl: 'https://www.mylocalforce.com/invoice/demo',
  amount: '$95.00',
  onboardingUrl: 'https://www.mylocalforce.com/provider/onboarding',
  actionUrl: 'https://www.mylocalforce.com/provider/application',
  updateDeadline: 'April 30, 2026',
  missingItems: 'Please upload your passport image and update your business address.',
  refundAmount: '$75.00',
  refundId: 're_demo_1234',
  refundStatus: 'succeeded',
  reason: 'customer requested cancellation',
  refundType: '(Partial Refund)',
};

function resolveValue(target, path) {
  return String(path || '')
    .split('.')
    .filter(Boolean)
    .reduce((acc, key) => {
      if (acc === null || acc === undefined) {
        return undefined;
      }
      return acc[key];
    }, target);
}

function escapeHtml(value) {
  return String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

export function renderTemplateString(template, values = {}) {
  return String(template || '').replace(/{{\s*([^}]+)\s*}}/g, (match, key) => {
    const value = resolveValue(values, key);
    if (value === undefined || value === null) {
      return '';
    }
    return escapeHtml(value);
  });
}

export function getTemplatePreviewValues(template = {}) {
  const templateValues = Array.isArray(template.variables)
    ? template.variables.reduce((acc, variableName) => {
      acc[variableName] = TEMPLATE_PREVIEW_VALUES[variableName] || `Sample ${variableName}`;
      return acc;
    }, {})
    : {};

  return {
    ...GLOBAL_TEMPLATE_PREVIEW_VALUES,
    ...templateValues,
  };
}
